/*
  MASTER — recuperación al cerrar el formulario de contraentrega.

  Por qué NO es el rescate de salida
  ----------------------------------
  El rescate de salida (master-exit-save.js) responde a "me voy de la tienda" y
  su respuesta es un DESCUENTO. Esto responde a otra cosa: "abrí el formulario
  de pedido y lo cerré sin pedir". Ahí el cliente no ha dicho que se va —ha
  dicho que ESA forma de pagar no le convenció—, así que la respuesta correcta
  no es rebajar el precio: es enseñarle la otra puerta.

  Y hay una razón económica para no darle un descuento aquí. En DivoPet el
  rescate es un 5%, que sobre un pack de 2 o 3 unidades vale MÁS que el
  incentivo de prepago de $5.000. Regalarlo por cerrar un formulario haría que
  contraentrega —la ruta cara, la que puede acabar en un pedido fallido— fuera
  la más barata para el cliente. Este archivo no aplica ningún código: sólo
  enruta a las dos acciones que ya existen.

  Quién decide que procede molestar es MasterPurchase (`rescueContext`), el
  mismo árbitro que ya usa el rescate de salida, para que no puedan abrirse los
  dos a la vez.
*/
(() => {
  if (window.MasterCodRecoveryLoaded) return;
  window.MasterCodRecoveryLoaded = true;

  const setup = modal => {
    if (modal.dataset.masterReady === 'true') return;
    modal.dataset.masterReady = 'true';

    const owner = modal.dataset.owner || 'global';
    const overlay = document.querySelector(`[data-cod-recovery-overlay][data-owner="${owner}"]`)
      || document.querySelector('[data-cod-recovery-overlay]');
    if (!overlay) return;

    const once = modal.dataset.once !== 'false';
    const delay = Math.max(0, Number(modal.dataset.delay || 0)) * 1000;
    const designMode = Boolean(window.Shopify?.designMode);
    const rescueId = `cod-recovery:${owner}`;
    const shownKey = `master-cod-recovery:shown:${location.host}:${owner}`;

    let previous = null;

    const session = {
      get: () => { try { return sessionStorage.getItem(shownKey) === '1'; } catch (_) { return false; } },
      set: () => { try { sessionStorage.setItem(shownKey, '1'); } catch (_) {} }
    };

    const shown = () => !designMode && once && session.get();
    const markShown = () => { if (!designMode && once) session.set(); };

    const hide = () => {
      if (modal.hidden) return;
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
      overlay.hidden = true;
      window.MasterScrollLock?.unlock('cod-recovery-open');
      window.MasterPurchase?.releaseRescue?.(rescueId);
      previous?.focus?.({ preventScroll: true });
    };

    const show = () => {
      if (shown()) return false;
      /* El árbitro compartido: el formulario COD sigue abierto, ya hubo pedido,
         o el rescate de salida tiene la pantalla. En cualquiera de esos casos
         esto no se abre. */
      if (!window.MasterPurchase?.claimRescue?.(rescueId)) return false;
      previous = document.activeElement;
      modal.hidden = false;
      overlay.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      window.MasterScrollLock?.lock('cod-recovery-open');
      requestAnimationFrame(() => modal.querySelector('[data-cod-recovery-prepay]')?.focus({ preventScroll: true }));
      markShown();
      return true;
    };

    /*
      El cierre del formulario del proveedor lo reemite MasterPurchase, que es
      el único que sabe leer su ciclo de vida. `completed` distingue "cerré sin
      pedir" de "pedí y el formulario se cerró solo": ofrecerle otra forma de
      pagar a quien acaba de comprar sería absurdo.

      El pequeño retraso deja que el <dialog> del proveedor termine de cerrarse
      antes de abrir nada encima; sin él, las dos animaciones se solapan.
    */
    document.addEventListener('master:cod-close', event => {
      if (event.detail?.completed) return;
      setTimeout(show, delay || 450);
    });

    modal.querySelectorAll('[data-cod-recovery-dismiss]').forEach(button => {
      button.addEventListener('click', hide);
    });
    overlay.addEventListener('click', hide);

    document.addEventListener('keydown', event => {
      if (modal.hidden || event.key !== 'Escape') return;
      event.preventDefault();
      hide();
    });

    /* Prepago. El código que promete el botón viaja con él
       (`data-purchase-discount`) y lo aplica MasterPurchase por la misma ruta
       que la CTA de prepago de la ficha: no hay una segunda implementación del
       descuento aquí. */
    modal.querySelector('[data-cod-recovery-prepay]')?.addEventListener('click', event => {
      const trigger = event.currentTarget;
      hide();
      window.MasterPurchase?.execute('native_checkout', { trigger });
    });

    /* Volver a contraentrega: se cierra esto y se reabre el formulario del
       proveedor con el nivel que el cliente ya tenía elegido. */
    modal.querySelector('[data-cod-recovery-cod]')?.addEventListener('click', () => {
      hide();
      setTimeout(() => window.MasterPurchase?.execute('open_cod', { fallback: 'open_cart' }), 120);
    });
  };

  const init = scope => {
    const modals = scope.matches?.('[data-cod-recovery]')
      ? [scope]
      : [...(scope.querySelectorAll?.('[data-cod-recovery]') || [])];
    modals.forEach(setup);
  };

  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
